<div class="company-initials-avatar-container container" fxLayoutAlign="center center"
     [ngStyle]="color ? {'background-color': color} : {}"
     [attr.aria-label]="'AVATAR.INITIALS' | translate: { initials: initials }"
     role="img">
  <div class="initials" [ngClass]="{'long': initials?.length > 2}">
    {{ initials || ('AVATAR.DEFAULT' | translate) }}
  </div>
</div>
